<template>
  <div v-if="detailsCondition" id="details">
    <template v-for="(item,indexOut) of detailsCondition">
      <div class="bd-details-wrap" v-if="item.type == 'default'" :key="indexOut">
        <!-- 统一处理不显示 icon -->
        <el-card :class="[item.titleIcon && false ? 'show-title-icon' : '']">
          <el-descriptions :column="item.rowColumn || rowColumn" :direction="direction" :colon="false">
            <template slot="title">
              <div>
                <div class="bd-details-title">
                  <img v-if="item.titleIcon && false" :src="item.titleIcon" class="title-icon"/>
                  {{ $t(item.topTitle) }}
                </div>
                <div>
                  <slot name="topState" v-if="item.isDisplayTopState"></slot>
                </div>
              </div>
            </template>
            <template v-if="item&&item.data">
              <template v-for="(subItem,index) of item.listTemplate">
                <template v-if="showRowItems(item, index, subItem) && !subItem.type">
                  <el-descriptions-item :span="subItem.span?subItem.span:1" :label="$t(subItem.titleBar.title)"
                                            :key="index">
                    <div class="content-inner" :class="{'has-more': subItem.showMore}">
                      <div class="sub-item-content" :style="{'max-height': `${itemMaxLine > 0 ? `${28 * itemMaxLine}px`: 'auto'}`}">
                        <div :ref="`sub-item-content-${indexOut}-${index}`" class="sub-item-content-text"
                          v-html="subItem.isInternationalization ? $t(getDisplayText(subItem, item.data, indexOut, index)) : getDisplayText(subItem, item.data, indexOut, index)"></div>
                      </div>
                      <div class="show-more-btn">
                        <span class="ellipsis">......</span>
                        <el-popover
                          placement="right"
                          :width="500"
                          trigger="click">
                          <div v-html="subItem.isInternationalization ? $t(getDisplayText(subItem, item.data)) : getDisplayText(subItem, item.data)"></div>
                          <template #reference>
                            <a>{{$t('message.common.more')}}</a>
                          </template>
                        </el-popover>
                      </div>
                    </div>
                  </el-descriptions-item>
                </template>
                <template v-if="showRowItems(item, index, subItem) && subItem.type && (subItem.type === 'add-tip')">
                  <el-descriptions-item :key="index">
                    <template slot="label">
                      {{ $t(subItem.titleBar.title) }}
                      <el-popover
                        placement="right"
                        :width="500"
                        trigger="click">
                        <div v-html="subItem.text"></div>
                        <template #reference>
                          <el-button type="text" icon="el-icon-warning-outline" size="mini"></el-button>
                        </template>
                      </el-popover>
                    </template>
                    <div style="white-space: normal">
                      {{
                        subItem.isInternationalization ? $t(getDisplayText(subItem, item.data)) : getDisplayText(subItem, item.data)
                      }}
                    </div>
                  </el-descriptions-item>
                </template>
                <template v-if="showRowItems(item, index, subItem) && subItem.type && (subItem.type === 'tag')">
                  <el-descriptions-item :span="subItem.span?subItem.span:1" :label="$t(subItem.titleBar.title)" :key="index">
                    <el-tag :type="subItem.tagTypeFunc ? subItem.tagTypeFunc(item.data) : 'danger'">
                      {{
                        subItem.isInternationalization ? $t(getDisplayText(subItem, item.data)) : getDisplayText(subItem, item.data)
                      }}
                    </el-tag>
                  </el-descriptions-item>
                </template>
                <template v-if="showRowItems(item, index, subItem) && subItem.type&&subItem.type=='click'">
                  <el-descriptions-item :span="subItem.span?subItem.span:1" :label="$t(subItem.titleBar.title)" :key="index">
                    <div>
                      <!-- 下载 -->
                      <el-button
                        style="padding-top:5px;padding-bottom: 5px;"
                        size="small"
                        v-if="(item.data && item.data[subItem.key] && subItem.buttonType === 'download')"
                        type="default"
                        @click="handleItemClick(subItem, item)">
                        <span style="color:#264373;">
                          {{
                            subItem.isInternationalization ? $t(getDisplayText(subItem, item.data)) : getDisplayText(subItem, item.data)
                          }}
                        </span>
                        <span style="margin-left:45px;font-size: 12px;margin-top: 1px;" class="iconfont icon-Download"></span>
                      </el-button>
                      <el-button v-else-if="(item.data && item.data[subItem.key])" type="text" @click="handleItemClick(subItem, item)">
                        {{
                          subItem.isInternationalization ? $t(getDisplayText(subItem, item.data)) : getDisplayText(subItem, item.data)
                        }}
                      </el-button>
                      <div v-else style="white-space: normal">
                        {{
                          subItem.isInternationalization ? $t(getDisplayText(subItem, item.data)) : getDisplayText(subItem, item.data)
                        }}
                    </div>
                    </div>
                  </el-descriptions-item>
                </template>
                <template v-if="showRowItems(item, index, subItem) && subItem.type && (subItem.type === 'slot')">
                  <el-descriptions-item :span="subItem.span?subItem.span:1" :label="$t(subItem.titleBar.title)" :key="index">
                    <slot :name="subItem.key"></slot>
                  </el-descriptions-item>
                </template>
              </template>
            </template>
          </el-descriptions>
          <div v-if="showItemMore(item)" class="more-tips" @click="handleItemMore(item)">
            <span>{{$t('message.common.showAll')}}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
        </el-card>
      </div>
      <div class="bd-details-wrap" v-if="item.type == 'table'&&item.data" :key="indexOut">
        <el-card :class="[item.titleIcon ? 'show-title-icon' : '']">
        <div class="el-descriptions">
          <div class="el-descriptions__header">
          <div class="el-descriptions__title">
            <div class="bd-details-title">
              <img v-if="item.titleIcon" :src="item.titleIcon" class="title-icon"/>
              {{ $t(item.topTitle) }}
            </div>
          </div>
         </div>
         <div style="margin-top: 20px">
          <custom-table :table-set="item.listTemplate"
                        :stored-data="item.data"
                        :is-pagination-display="false"></custom-table>
          </div>
        </div>
        </el-card>
      </div>
    </template>
  </div>
</template>

<script>

import CustomTable from '@/components/table/custom-table.vue';
import { isNullForDisplay } from '@/utils/tools/utils';

export default {
  name: 'DetailsComponent',
  components: { CustomTable },
  props: {
    /**
     * 模版
     */
    detailsCondition: {
      type: Array,
      default: () => ([]),
    },
    /**
     * 模版
     */
    rowColumn: {
      type: Number,
      default: 2,
    },
    /**
     * 内容最大显示行数，超出省略
     */
    itemMaxLine: {
      type: Number,
      default: 2,
    },
    direction: {
      type: String,
      default: 'horizontal',
    },
  },
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    getDisplayText(item, data, indexOut, index) {
      if (typeof index === 'number') {
        this.$nextTick(() => {
          const contentRef = this.$refs[`sub-item-content-${indexOut}-${index}`];
          if (contentRef) {
            const height = contentRef[0].offsetHeight;
            if (this.itemMaxLine && height > (28 * this.itemMaxLine)) {
              item.showMore = true;
            }
          }
        });
      }
      return (item.textFunc ? item.textFunc(data) : (isNullForDisplay(data[item.key], '--') || '--'));
    },
    handleItemClick(subItem, item) {
      if (subItem.func && item.data && item.data[subItem.key]) {
        subItem.func(item.data);
      }
    },
    showRowItems(item, index, subItem) {
      if (subItem.isDisplayFunc && !subItem.isDisplayFunc(item.data)) {
        return false;
      }
      if (item.showAll) {
        return true;
      }
      const initRows = item.initRows || 5; // 初始化显示行数，默认 6 行，超出省略
      const maxNum = (initRows * this.rowColumn);
      return index < maxNum;
    },
    showItemMore(item) {
      if (item.showAll) {
        return false;
      }
      const initRows = item.initRows || 5; // 初始化显示行数，默认 6 行，超出省略
      const maxNum = (initRows * this.rowColumn);
      if (item.listTemplate.length > maxNum) {
        return true;
      }
      return false;
    },
    handleItemMore(item) {
      item.showAll = !item.showAll;
      this.$forceUpdate();
      // 渲染完成后，再次渲染以便计算每个内容是否超出需要隐藏
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';

#details {
  .bd-details-wrap {
    overflow: hidden;
    background: #FFFFFF;
    border-top: 1px solid #EBEEF5;

    &:last-child {
      border-bottom: 1px solid #EBEEF5;
    }

    .el-card {
      border: none;

      &.show-title-icon {
        .el-card__body {
          padding-left: 33px;
        }
      }
    }

    .more-tips {
      display: inline-flex;
      align-items: center;
      font-size: 14px;
      font-family: Avenir-Heavy, Avenir;
      font-weight: 800;
      color: $color-text-default-button;
      line-height: 28px;
      margin-top: 11px;
      cursor: pointer;

      .el-icon-arrow-down {
        margin-left: 10px;
        font-size: 12px;
      }
    }

    .bd-details-title {
      position: relative;
      font-size: 16px;
      font-weight: 800;
      color: $color-text-primary;
      font-family: Avenir-Heavy, Avenir;
      line-height: 25px;

      .title-icon {
        position: absolute;
        left: -33px;
        top: 50%;
        transform: translateY(-50%);
        width: 24px;
        height: 24px;
      }
    }

    .el-button--mini {
      min-height: 20px;
      padding: 0 15px;
      font-size: 14px;
    }
  }
  .el-descriptions__header {
    margin-bottom: 10px;
  }
  .el-descriptions__title{
    width: 100%;
  }
  .el-descriptions-item__cell {
    padding-bottom: 5px;
  }
  .el-descriptions-item__label {
    color: $color-description;
    font-weight: normal;
    line-height: 28px;
    font-size: 14px;
    width: 200px;
    min-width: 200px;
  }

  .el-descriptions-item__content {
    color: $color-text-primary;
    word-break: break-all;
    font-weight: 800;
    line-height: 28px;
    font-size: 14px;
    font-family: Avenir-Heavy, Avenir;
    margin-right: 20px;

    .el-button--text {
      padding: 0;
      font-size: 14px;
      min-width: 0;
    }

    .content-inner {
      position: relative;
      .sub-item-content {
        overflow: hidden;
        // max-height: 56px;
      }
      .show-more-btn {
        position: absolute;
        right: 0;
        bottom: 0;
        background: #FFFFFF;
        display: none;
        .ellipsis {
          padding-right: 15px;
        }
        a {
          cursor: pointer;
        }
      }
      &.has-more .show-more-btn{
        display: block;
      }
    }
  }
}
</style>
